<template>
  <div class="card-content">
    <div class="card-body">
      <div class="media d-flex">
        <div class="media-body">
          <h5 class="card-title skokka-text">
            <i class="float-left mr-2"> Testers Buttons: </i>
          </h5>
          <br />
          <br />
          <h5 class="card-title skokka-text">
            <i class="float-left mr-2"> YOTI </i>
          </h5>
          <br />
          <button
            type="button"
            class="btn btn-primary"
            @click="changeVerificationStatus(2)"
          >
            + User Pending Yoti
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="changeVerificationStatus(3)"
          >
            + User Verified Yoti
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="changeVerificationStatus(1)"
          >
            + User Rejected Yoti
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="deleteDocumentHashes()"
          >
            - Delete Yoti User document hash
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import changeYotiVerificationStatus from '../../js/utils/api_calls'

  export default {
    name: 'TesterFrontendUserActionButtons',
    props: {
      changeVerificationStatusUrl: {
        type: String,
        required: true,
      },
      deleteDocumentHashesUrl: {
        type: String,
        required: true,
      },
    },
    data() {
      return {}
    },
    computed: {},
    methods: {
      async deleteDocumentHashes() {
        try {
          const csrfToken = this.$cookies.get('csrftoken')
          if (!csrfToken) {
            throw new Error('CSRF token not found.')
          }

          const headers = {
            'X-CSRFToken': csrfToken,
          }
          const response = await this.$http.post(this.deleteDocumentHashesUrl, {}, { headers })
          if (response?.status === 200) {
            window.location.reload()
          } else {
            const errorMessage = response.data?.data?.message || 'An unknown error occurred.'
            throw new Error(errorMessage)
          }
        } catch (error) {
          console.error('Error deleting document hashes:', error.message)

          window.showErrorTopAlertWithTimer()
        }
      },

      async changeVerificationStatus(status) {
        await changeYotiVerificationStatus(status, this.changeVerificationStatusUrl)
      },
    },
  }
</script>
